import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import Swal from "sweetalert2";
import Button from '../../../components/Button/Button';
import Skeleton from "react-loading-skeleton";

import { formValidation, clearFormValidation, filterErrorHandler } from '../../../hoc/Shared/utility';
import ValidationError from '../../../components/ValidationError/ValidationError';

import { getMemberGameAccess, updateMemberGameAccess } from "../../../store/ducks/member/actions";

class MemberGameAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            errMsg: [],
            touched: false,
            formFilter: {},
            existingFormFilter: {},
            access: [],
            update: false
        }
    }

    componentDidMount() {
        formValidation('game_access_form');
        let params = {};
        params.member_id = this.props.memberEditId;
        this.props.getMemberGameAccess(params);
    }

    shouldComponentUpdate(nextProps, nextState) {
        // console.log("[shouldComponentUpdate]", nextProps);
        if (nextProps.member_game_access !== undefined && nextProps.member_game_access !== this.props.member_game_access) {
            if (nextProps.member_game_access.responseCode === 200 && nextProps.member_game_access.msgType === "success") {
                let newFilter = [];
                let existingFilter = [];
                let update = false;

                nextProps.member_game_access.data.result.vendor.map((main, idx) => {
                    newFilter[`cb_${main.id}_0`] = true;
                    if (nextProps.member_game_access.data.result.category[main.id]) {
                        nextProps.member_game_access.data.result.category[main.id].forEach((sub, idx) => {
                            newFilter[`cb_${main.id}_${sub.id}`] = true;
                        });
                    }
                    return null;
                });

                if (nextProps.member_game_access.data.result.access.length > 0) {
                    update = true;
                    nextProps.member_game_access.data.result.access.forEach((item, idx) => {
                        if (item.status === 1) {
                            newFilter[`cb_${item.vendor_id}_${item.game_id}`] = false;
                        }
                        existingFilter[`cb_${item.vendor_id}_${item.game_id}`] = true;
                    });
                }

                this.setState({
                    data: nextProps.member_game_access.data.result,
                    loading: false,
                    formFilter: newFilter,
                    existingFormFilter: existingFilter,
                    update: update
                });
            }
            else {
                this.setState({
                    data: [],
                    loading: false,
                    formFilter: {},
                    existingFormFilter: {},
                    update: false
                }, () => {
                    filterErrorHandler(nextProps.member_game_access.message);
                })
            }
        }

        if (nextProps.member_update_game_access !== undefined && nextProps.member_update_game_access !== this.props.member_update_game_access) {
            if (nextProps.member_update_game_access.responseCode === 200 && nextProps.member_update_game_access.msgType === "success") {
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.member_update_game_access.msgType,
                    confirmButtonText: t("global.ok")
                }).then((result) => {
                    if (result.isConfirmed) {
                        clearFormValidation('game_access_form');
                        this.refreshHandler();
                    }
                });
            }
            else {
                this.setState({
                    touched: true,
                    errMsg: nextProps.member_update_game_access.message
                });
                Swal.close();
            }
        }
        return true;
    }

    refreshHandler = () => {
        this.setState({
            data: [],
            loading: true
        }, () => {
            let params = {};
            params.member_id = this.props.memberEditId;
            this.props.getMemberGameAccess(params);
        });
    }

    submitHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t('global.confirmation'),
            text: t('global.are-you-sure'),
            icon: 'warning',
            confirmButtonText: t('global.save'),
            showDenyButton: true,
            denyButtonText: t('global.cancel'),
        })
            .then((res) => {
                if (res.isConfirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        didOpen: () => {
                            Swal.showLoading()
                        }
                    });

                    let existing = this.state.data.access ? this.state.data.access : [];
                    let existingAccess = Object.assign({}, this.state.existingFormFilter);
                    let existingAccessGame = [];

                    let data = {};
                    let access = Object.assign({}, this.state.formFilter);
                    let accessGame = [];

                    data.member_id = this.props.memberEditId;
                    data.admin_id = this.props.currentUser.id;

                    for (const key in access) {
                        if (key.includes('cb_')) {
                            if (access[key] === false) {
                                let tmp = key.split('_');
                                accessGame.push([tmp[1], tmp[2]]);
                            }
                        }
                    }
                    data.access_list = accessGame;

                    if (existing.length > 0) {
                        for (const key in existingAccess) {
                            if (key.includes('cb_')) {
                                if (existingAccess[key] === true) {
                                    let tmp2 = key.split('_');
                                    existingAccessGame.push([tmp2[1], tmp2[2]]);
                                }
                            }
                        }
                    }

                    data.existing_access_list = existingAccessGame;
                    data.update = this.state.update;
                    // console.log(data);
                    this.props.updateMemberGameAccess(data);
                }
            });
    }

    checkAllHandler = (e) => {
        let checkVal = (e.target.checked) ? true : false;
        let newFilter = Object.assign({}, this.state.formFilter);
        // console.log(newFilter);
        for (const key in newFilter) {
            if (key.includes('cb_')) {
                newFilter[key] = checkVal;
            }
        }

        this.setState({
            formFilter: newFilter,
        });
    }

    onCheckBoxChange = (e, type, id) => {
        let checkVal = '';
        let newModule = Object.assign({}, this.state.formFilter);

        for (const key in newModule) {
            if (key.includes('cb_')) {
                let tmp = key.split('_');

                if (type === 'main' && (tmp[1] === id.toString())) {
                    checkVal = (newModule[`cb_${id}_${tmp[2]}`]) ? false : true;
                    if (checkVal) { break; }
                }

                if (type === 'sub' && (tmp[2] === id.toString())) {
                    checkVal = (newModule[`cb_${tmp[1]}_${id}`]) ? false : true;
                    if (checkVal) { break; }
                }
            }
        }

        for (const key in newModule) {
            if (key.includes('cb_')) {
                let tmp = key.split('_');

                if (type === 'main' && tmp[1] === id.toString()) {
                    newModule[`cb_${id}_${tmp[2]}`] = checkVal;
                }

                if (type === 'sub' && tmp[2] === id.toString()) {
                    newModule[`cb_${tmp[1]}_${id}`] = checkVal;
                }
            }
        }

        this.setState({
            formFilter: newModule,
        });
    }

    render() {
        const { t } = this.props;
        let inputArr = this.state.formFilter ? this.state.formFilter : [];
        let vendor = this.state.data.vendor ? this.state.data.vendor : [];
        let category = this.state.data.category ? this.state.data.category : [];
        return (
            <Auxiliary>
                <div className="row row-sm">
                    <div className="col-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("member.edit-game-access")}</h4>
                            </div>
                            <div className="card-body pt-0">
                                <form method='post' id='game_access_form' className='form-horizontal' onSubmit={this.submitHandler} noValidate>
                                    <ValidationError formName='game_access_form' touched={this.state.touched} message={this.state.errMsg} />
                                    {this.state.loading
                                        ?
                                        <Skeleton count={3} />
                                        :
                                        <>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    <div className='form-group mb-0'>
                                                        <div className="yl-checkbox-container">
                                                            <input type='checkbox' id='check_all' name='check_all' onClick={(event) => this.checkAllHandler(event)} />
                                                            <label className="margin-r" for='check_all'>{t('member.all')}</label>
                                                        </div>

                                                    </div>
                                                    <div className='col-md-12 border border-light rounded'>
                                                        <ul id='tree1' className='tree'>
                                                            {
                                                                vendor.map((main, idx) => {
                                                                    let categoryUI = [];
                                                                    let content = [];

                                                                    if (category[main.id]) {
                                                                        category[main.id].forEach((sub, idx1) => {
                                                                            let title = sub.slug.split("_");
                                                                            content.push(
                                                                                <span key={idx1}>
                                                                                    <div className="yl-checkbox-container">
                                                                                        <input
                                                                                            id={`cb_${main.id}_${sub.id}`}
                                                                                            name={`cb_${main.id}_${sub.id}`}
                                                                                            type='checkbox'
                                                                                            className='child'
                                                                                            checked={(inputArr[`cb_${main.id}_${sub.id}`]) ? inputArr[`cb_${main.id}_${sub.id}`] : false}
                                                                                            onChange={(event) => this.onCheckBoxChange(event, 'sub', sub.id)}
                                                                                            style={{ cursor: 'pointer' }}
                                                                                        />
                                                                                        <label className="margin-r" for={`cb_${main.id}_${sub.id}`}>{t(`game-type.${title[1]}`)}</label>
                                                                                    </div>
                                                                                </span>
                                                                            );
                                                                        });
                                                                    }

                                                                    categoryUI.push(<ul key={idx}><li>{content}</li></ul>);

                                                                    return (
                                                                        <li key={idx}>
                                                                            <span key={idx}>
                                                                                <div className="yl-checkbox-container">
                                                                                    <input
                                                                                        id={`cb_${main.id}_0`}
                                                                                        name={`cb_${main.id}_0`}
                                                                                        type='checkbox'
                                                                                        className='child'
                                                                                        checked={(inputArr[`cb_${main.id}_0`]) ? inputArr[`cb_${main.id}_0`] : false}
                                                                                        onChange={(event) => this.onCheckBoxChange(event, 'main', main.id)}
                                                                                        style={{ cursor: 'pointer' }}
                                                                                    />
                                                                                    <label className="margin-r" for={`cb_${main.id}_0`}>&nbsp;{t(`vendor.${main.slug}`)}</label>
                                                                                </div>
                                                                            </span>
                                                                            {categoryUI}
                                                                        </li>
                                                                    );
                                                                })
                                                            }
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group mb-0 mt-3 justify-content-end'>
                                                <div>
                                                    {(this.props.permission.includes('member_game_access')) && vendor.length > 0 &&
                                                        <Button typeButton='submit' classValue='btn btn-blue' idValue='save' buttonName={t('global.save')} />}
                                                </div>
                                            </div>
                                        </>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        member_game_access: state.member.member_game_access,
        member_update_game_access: state.member.member_update_game_access,
        currentUser: state.currentUser.data
    }
}

const mapDispatchToProps = {
    getMemberGameAccess,
    updateMemberGameAccess
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberGameAccess));